import { TwoFactor } from '../../js/Twofactor';
import '../../css/twofactor.css';

const $ = jQuery;

$(document).ready(function() {
    if ($('.stockpress-login-form').length === 0) {
        return;
    }

    const codeField = new TwoFactor(document.getElementById('email-confirmation-code'), 6);

    $('.login-form').on('submit', 'form.stockpress-login-form', function(e) {
        e.preventDefault();

        const form = $(this);
        let error = false;
        form.find('.error-message-field').hide();
        form.find('input').removeClass('error');
        const attrs = {};
        form.find('input[required]').each(function() {
            form.removeClass('error');
            let value = $(this).val();
            if (value == '') {
                $(this).addClass('error');
                error = true;
            }
            attrs[$(this).attr('name')] = value;
        });
        attrs.n_password = $('input[name="n_password"]').val();

        if (error) {
            form.find('.error-message').show();
            return;
        } else {
            form.find('.error-message').hide();
        }

        const button = form.find('button[type="submit"]');
        button.attr('disabled', true);
        button.html('Please wait...');
        form.find('input').attr('disabled', true);

        attrs.action = 'stockpress_login';
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'post',
            data: attrs,
            dataType: 'json',
            success: function(response) {
                const { data } = response;
                if (data.status == 'success') {
                    form.hide();
                    form.parent().find('.email-confirmation').show();
                    form.parent().find('.email-cofirmation-email span').html(attrs.user_email);
                }
            },
            error: function(response) {
                const { data } = response.responseJSON;
                if (data) {
                    Object.keys(data).forEach(function(key) {
                        if (key === 'errors' && data[key].api) {
                            errorEl = form.find('div.api-error-message');
                            errorEl.html(data[key].api);
                            errorEl.show();
                        }
                        const el = form.find('input[name="' + key + '"]');
                        let errorEl = el.parent('label').find('div.error-message-field');
                        if (errorEl) {
                            el.addClass('error');
                        }
                        errorEl.html(data[key]);
                        errorEl.show();
                        $('html,body').animate({ scrollTop: form.offset().top - 50 });
                    });
                }
            },
            complete: function() {
                button.removeAttr('disabled');
                button.html('Sing in with email');
                form.find('input').removeAttr('disabled');
            }
        });
    });

    $('#email-confirmation-code').on('submit', 'form.stockpress-login-confirm-form', function(e) {
        e.preventDefault();

        const form = $(this);

        let isCodeValid = true;
        let inputCode = '';
		for (let input of codeField.inputs) {
			if (TwoFactor.validateNumericInput(input) === false) {
				isCodeValid = false;
			}
			inputCode += input.value;
			input.blur();
		}
        if (!isCodeValid) {
            return;
        }

        const button = form.find('button[type="submit"]');
        button.attr('disabled', true);
        button.html('Please wait...');
        form.find('input').attr('disabled', true);

        $.ajax({
            url: ajax_object.ajax_url,
            type: 'post',
            data: {
                action: 'stockpress_login_verify',
                code: inputCode,
            },
            dataType: 'json',
            success: function(response) {
                const { data } = response;
                let html = '';
                if (response.success) {
                    data.forEach((account) => {
                        html += `
                        <div class="email-account">
                            <a href="${account.url}" target="_blank">
                                <div class="email-account-icon">
                                    <span style="background-color: ${account.color};">
                                        ${account.name.charAt(0).toUpperCase()}
                                    </span>
                                </div>
                                <div class="email-account-details">
                                    <h4 class="email-account-domain">
                                        ${account.domain}
                                    </h4>
                                    <span class="email-account-name">
                                        ${account.user_name} (${account.role_name})
                                    </span>
                                </div>
                                <i class="fas fa-arrow-right"></i>
                            </a>
                        </div>
                        `;
                    });
                    if (data.length === 0) {
                        html = `
                        <div class="email-account-nothing-found">
                            There are no accounts associated with this email address.
                        </div>
                        `;
                    }
                    $('.email-confirmation').hide();
                    $('.email-confirmation-accounts').html(html);
                    $('.success-message').show();
                    $('html,body').animate({ scrollTop: $('.email-confirmation').offset().top - 50 });
                }
            },
            error: function(response) {
                const { data } = response.responseJSON;
                if (data) {
                    if (data.error) {
                        const errorEl = $('.email-confirmation .api-error-message');
                        errorEl.html(data.error);
                        errorEl.show();
                    }
                }
            },
            complete: function() {
                button.removeAttr('disabled');
                button.html('Confirm');
                form.find('input').removeAttr('disabled');
            }
        });
    });
});



// WEBPACK FOOTER //
// ./src/js/login.js